<div class="{{ initOptions.style }}">
  <input
    type="checkbox"
    name="{{ initOptions.id }}"
    id="{{ initOptions.id }}"
    value="{{ initOptions.value }}" />
  <label id="{{ initOptions.id }}-label" for="{{ initOptions.id }}">{{
    initOptions.inner_text
  }}</label>
</div>
